/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
interface Signature {
  Args: {
    form?: unknown;
  };
}

import { capitalize } from "@ember/string";
import Component from "@glimmer/component";

const HistologyCodes = ["CIC", "CCI", "CLI", "CCIS"];

export default class MedicalHistoryFormBreastCancerComponent extends Component<Signature> {
  capitalize = capitalize;

  get histologyCodes(): string[] {
    return HistologyCodes;
  }

  get hormonalPercentageValues(): number[] {
    const values: number[] = [];
    for (let i = 0; i <= 100; i += 10) {
      values.push(i);
    }
    return values;
  }
}
